import {IntermediatePart} from "../../intermediatePart";

export default class Chair extends IntermediatePart {

  constructor(isChild) {
    super(isChild);
    this.partId = 'chair';
    this.partName = 'Chair';
    this.translateId = "visualizer.bathroom.shower.chair";
    this.canBeDisabled = true;
  }

}
